import apiClient from './client'
import { GroupedSuggestion } from '@/types/admin'

interface CleanupResult {
  message: string
  checked: number
  deleted: number
  failed: number
}

export const suggestionsApi = {
  list: async () => {
    const response = await apiClient.get<{ suggestions: GroupedSuggestion[] }>('/admin/suggestions')
    return response.suggestions
  },

  cleanupOrphaned: async () => {
    const response = await apiClient.post<CleanupResult>('/admin/suggestions/cleanup-orphaned', {})
    return response
  },

  exportForCsv: async () => {
    const response = await apiClient.get<{ suggestions: GroupedSuggestion[] }>(
      '/admin/suggestions/export',
    )
    return response.suggestions
  },
}
